import axios from "axios";
import React, { useEffect, useState, useContext, useRef } from "react";
import { Col, Nav, Row, Tab } from "react-bootstrap";
import ChooseTemplateCard from "../../Components/Template/ChooseTemplateCard";
import { ChooseTemplate, TemplateType } from "../../Models/ChooseTemplate";
import { apiConf, ROOT_PATH, templateActionEnum } from "../../Config/Constants";
import TemplateDataContext from "../../Contexts/TemplateData.context";
import { EnableHomeRenderFromBlob } from "../../Util/general-config";
import Select, { ActionMeta, SingleValue } from "react-select";
import { Link } from "react-router-dom";

type Option = {
  value: string;
  label: string;
};

const Home = () => {
  const [chooseTemplateTypeList, setChooseTemplateTypeList] = useState({} as TemplateType);
  const { dispatch } = useContext(TemplateDataContext);
  const [sortOption, setSortOption] = useState<Option | null>();
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    (async () => {
      try {
        if (EnableHomeRenderFromBlob() == false) {
          const response = await axios.get(`../../data/HomePage-WS.json`);
          if (response.data) {
            setChooseTemplateTypeList(response.data);
          } else {
            throw response;
          }
        } else {
          // default file from blob..
          const response = await axios.get(`${apiConf.developmentBaseUrlForObject}/HomePage-WS.json`);
          if (response.data) {
            setChooseTemplateTypeList(response.data);
          } else {
            throw response;
          }
        }
      } catch (error) {
        console.error("🔥 ~ fetchHomeData ~ error", error);
      }
    })();
  }, []);

  useEffect(() => {
    const tempContainer = document.querySelector(".choose-template-container");
    const footerAlign = document.querySelector("#minimal-footer");

    if (tempContainer && footerAlign) {
      (footerAlign as HTMLElement).style.position = "relative";
    } else {
      (footerAlign as HTMLElement).style.position = "";
    }

    dispatch({ type: templateActionEnum.LOAD_TEMPLATE, payload: [] });
  }, []);

  const sortTemplate = ["Popular Title", "A-Z", "Z-A"];
  const optionList: Option[] = sortTemplate.map((opt) => ({
    value: opt,
    label: opt,
  }));
  const sortTemplates = (sortingStrategy: (a: ChooseTemplate, b: ChooseTemplate) => number) => {
    const sortedList = { ...chooseTemplateTypeList };
    Object.keys(sortedList).forEach((key) => {
      sortedList[key].sort(sortingStrategy);
    });
    setChooseTemplateTypeList(sortedList);
  };

  const sortByAlphabeticalTitle =
    (ascending = true) =>
    (a: { title: string }, b: { title: string }) => {
      return ascending ? a.title.localeCompare(b.title) : b.title.localeCompare(a.title);
    };

  const sortByPopularTitle =
    (ascending = true) =>
    (a: { rank: number }, b: { rank: number }) => {
      return ascending ? a.rank - b.rank : b.rank - a.rank;
    };

  const handleSortChange = (selectedOption: SingleValue<Option>) => {
    if (!selectedOption) {
      setSortOption(null);
      sortTemplates(sortByPopularTitle());
    } else {
      setSortOption(selectedOption);
      switch (selectedOption.value) {
        case "Popular Title":
          sortTemplates(sortByPopularTitle());
          break;
        case "A-Z":
          sortTemplates(sortByAlphabeticalTitle());
          break;
        case "Z-A":
          sortTemplates(sortByAlphabeticalTitle(false));
          break;
        default:
          break;
      }
    }
  };

  const searchPost = (query: string) => {
    setSearchQuery(query);
  };

  const filterTemplates = (templateList: TemplateType, query: string) => {
    const filteredTemplates: TemplateType = {};
    let hasSearchResults = false;

    Object.keys(templateList).forEach((key) => {
      filteredTemplates[key] = templateList[key].filter((template) =>
        template.title.toLowerCase().includes(query.toLowerCase())
      );
      if (filteredTemplates[key].length > 0) {
        hasSearchResults = true;
      }
    });

    return hasSearchResults ? filteredTemplates : null;
  };
  const clearSearch = () => {
    setSearchQuery("");
  };

  const filteredTemplateList = searchQuery
    ? filterTemplates(chooseTemplateTypeList, searchQuery)
    : chooseTemplateTypeList;

    const firstTemplate =
  filteredTemplateList &&
  Object.values(filteredTemplateList)[0]?.[0];
  return (
    <>
      <div className="container choose-template-container">
        {/* <div className="card-header headerheight">
                </div> */}
        <div className="title-wrap text-center">
          <h1 className="page-title fw-bold ">Choose the template type</h1>{" "}
        </div>
        <div className="mt-5 p-1 p-md-2">
          {Object.keys(chooseTemplateTypeList).length ? (
            <Tab.Container id="left-tabs-example" defaultActiveKey={Object.keys(chooseTemplateTypeList)[0]}>
              <Row>
                <Col sm={12}>
                  <Nav variant="pills" className="d-flex justify-content-center">
                    <>
                      {Object.keys(chooseTemplateTypeList).map((templateKey, nvaLinkIndex) => (
                        <Nav.Item className="ms-3" key={nvaLinkIndex}>
                          <Nav.Link eventKey={templateKey} className="tabs">
                            {templateKey}
                          </Nav.Link>
                        </Nav.Item>
                      ))}
                    </>
                  </Nav>
                  <div className="d-flex justify-content-between mt-4">
                    <div className="search-bar input-group w-50">
                      <button type="button" className="btn bg-transparent p-0" aria-label="Search">
                        <i className="fa fa-search px-3 " style={{ color: "#FF6600" }} />
                      </button>
                      <input
                        id="search-input-home"
                        type="text"
                        className="form-control border-0"
                        placeholder="Search thousands of legal documents and forms"
                        style={{ minHeight: "38px" }}
                        value={searchQuery}
                        onChange={(e) => searchPost(e.target.value)}
                      />
                      {searchQuery && (
                        <button
                          type="button"
                          className="btn p-0"
                          onClick={clearSearch}
                          style={{
                            backgroundColor: "#e7f1ff",
                            borderTopRightRadius: "18px",
                            borderBottomRightRadius: "18px",
                            borderTopLeftRadius: "0px",
                            borderBottomLeftRadius: "0px",
                          }}
                          aria-label="Clear search"
                        >
                          <i className="fa fa-times px-3 text-muted opacity-50" />
                        </button>
                      )}
                    </div>
                    <div className=" col-sm-2">
                      <Select
                        className="sorting px-1 "
                        options={optionList}
                        isClearable
                        placeholder="Sort templates"
                        value={sortOption}
                        onChange={handleSortChange}
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 4,
                          colors: {
                            ...theme.colors,
                            primary25: "primary50",
                            primary: "#C0C0C0",
                          },
                        })}
                      />
                    </div>
                  </div>
                </Col>
                <Col sm={12} className="mt-5">
                  <Tab.Content>
                    {filteredTemplateList ? (
                      Object.keys(filteredTemplateList).map((templateKey, nvaLinkIndex) => (
                        <Tab.Pane eventKey={templateKey} key={nvaLinkIndex}>
                          <Row>
                            {filteredTemplateList[templateKey].map((template, index) => (
                              <Col md={6} key={index}>
                                <ChooseTemplateCard {...template} />
                              </Col>
                            ))}
                          </Row>
                        </Tab.Pane>
                      ))
                    ) : (
                      <div className="text-center">No results found</div>
                    )}
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          ) : (
            <></>
          )}
        </div>
      </div>
      <section
        id="s-pre-footer"
        style={{
          background: "linear-gradient(86.41deg, #D2E5FF, #f9e6f6 51.11%, #fff 97.53%)",
          paddingTop: "1rem",
          paddingBottom: "2.5rem",
          width: "100%",
        }}
      >
        <div className="text-center py-5">
          {/* SVG Graphic */}
          <div className="pb-5">
            <svg
              className="w-100"
              fill="none"
              height="122"
              viewBox="0 0 231 122"
              width="231"
              xmlns="http://www.w3.org/2000/svg"
              style={{ maxWidth: "384px" }}
            >
              <g opacity="0.8" style={{ mixBlendMode: "screen" }}>
                <path d="M93.5215 64.1818L130.34 101L220.34 11" stroke="white" strokeWidth="28.6364" />
                <path d="M9.6582 49.8636L58.7491 101L148.749 11" stroke="white" strokeWidth="24.5455" />
              </g>
            </svg>
          </div>

          {/* Heading */}
          <h4
            className="fw-semibold text-center mb-4"
            style={{ fontSize: "3.5rem", color: "#16283D", lineHeight: "1.2" }}
          >
            We make work{" "}
            <span
              style={{
                background: "linear-gradient(90deg, #1DCAFF 32.34%, #0E76FF 66.86%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                fontWeight: "bold",
              }}
            >
              simple
            </span>
          </h4>

          {/* Subtext */}
          <p className="text-muted fs-5 px-3">
            The all-in-one document tool suite that will transform the way you work
          </p>

           <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
      {/* {filteredTemplateList && Object.keys(filteredTemplateList).length > 0 && (
        <Link
          id="get-started-button"
          to={`/${ROOT_PATH}/${Object.values(filteredTemplateList)[0][0].link}`}
          className="btn primary-button btn-orange"
        >
          Get Started Now
        </Link>
      )} */}
   {firstTemplate?.link && (
  <Link
    id="get-started-button"
    to={`/${ROOT_PATH}/${firstTemplate.link}`}
    className="btn primary-button btn-orange"
  >
    Get Started Now
  </Link>
)}

    </div>
        </div>
      </section>
    </>
  );
};

export default Home;
